import { CMS_SITES_LINKS_MAPPER } from '@bcf-v2-configurators/tokens/cms-sites-links-mapper/token';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { provideDiTokenValue } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { TranslationConfig } from '../i18n-cache';

type CmsSimpleSite =
  | 'about-us'
  | 'cookies-policy'
  | 'privacy-policy'
  | 'refund-policy'
  | 'responsible-gaming'
  | 'sitemap'
  | 'standard-promotion-and-bonus-terms'
  | 'terms-and-conditions'
  | 'vip-information'
  | 'terms-for-each-sport'
  | 'general-betting-rules'
  | 'bonus-terms'
  | 'terms-promotion-and-bonus';

export type CmsSimplePageRouteFn = (cmsSimpleSite: CmsSimpleSite) => string;

// no slash on end
export function cmsSimplePageRoutePath(cmsSimpleSite: CmsSimpleSite, config?: TranslationConfig): string {
  const mapper: Record<string, string | undefined> = provideDiTokenValue(CMS_SITES_LINKS_MAPPER);
  return `/${langRouteI18n(config)}/sp/${mapper[cmsSimpleSite] ?? cmsSimpleSite}/`;
}
